module.exports = __webpack_public_path__ + "static/NurofenText_W_Rg-a34d9d46dfab217f0a2ad246ba699edf.woff";